import styled from 'styled-components';
import { colors } from '~/design_system/styles/colors';

export const DivisorStyled = styled.span`
  width: 100%;
  border: 1px solid ${colors.grey_20};
  display: flex;
`;
